/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-11-01 10:06:04
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-01-31 09:50:38
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/ClickAndCollect/index.tsx
 */
import { get } from 'lodash';
//import css from './css.module.less';
import React from 'react';
import { SectionWrapper } from 'src/components/Layouts';
//import Category from './Components/Category';
//import { NoWrapContainer } from 'src/components/GlobalTooltip/GlobalTooltip';
import {
  Collected,
  Notified,
  ReadyToCollect,
  ReadyToPack,
} from 'src/pages/Order/AllOrders/OrderDetail/ParcelProcess';
import { IFulfillmentStatus } from 'src/types/common/order';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const PickAndPack = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };

  const {
    data,
    orderNo,
    onUpdate,
    onUndo,
    pickupPersonName,
    totalPrice,
    buyerName,
    pickupLocation,
    recipientPhoneNo,
    customerPaid,
    collectShop,
    collectDate,
    returnFun,
    disabled,
    disablePrint,
  } = props;
  const pickedItems = get(data, IFulfillmentStatus.READY_TO_PACK, []);
  // const packedItems = get(data, IFulfillmentStatus.READY_TO_SHIP, []); //for testing
  const packedItems = get(data, IFulfillmentStatus.READY_TO_COLLECT, []);
  const noticedItems = get(data, IFulfillmentStatus.NOTIFIED, []);
  const collectedItems = get(data, IFulfillmentStatus.COLLECTED, []);
  // console.log('noticedItems', noticedItems);
  return (
    <React.Fragment>
      <SectionWrapper
        title={getI18n(
          `allOrders.orderDetail.clickandcollect_return_section_title`,
        )}>
        {pickedItems.length ? (
          <ReadyToPack
            data={pickedItems}
            orderNo={orderNo}
            onUpdate={onUpdate}
            disabled={disabled}
            disablePrint={disablePrint}
            onUndo={onUndo}
          />
        ) : null}
        {packedItems.length ? (
          <ReadyToCollect
            data={packedItems}
            orderNo={orderNo}
            onUpdate={onUpdate}
            disabled={disabled}
            disablePrint={disablePrint}
            onUndo={onUndo}
          />
        ) : null}
        {noticedItems.length ? (
          <Notified
            data={noticedItems}
            orderNo={orderNo}
            onUpdate={onUpdate}
            onUndo={onUndo}
            totalPrice={totalPrice}
            customerPaid={customerPaid}
            recipientPhoneNo={recipientPhoneNo}
            pickupLocation={pickupLocation}
            collectShop={collectShop}
            pickupPersonName={pickupPersonName}
            collectShop={collectShop}
            disabled={disabled}
            disablePrint={disablePrint}
            buyerName={buyerName}
            collectShop={collectShop}
          />
        ) : null}
        {collectedItems.length ? (
          <Collected
            data={collectedItems}
            orderNo={orderNo}
            onUpdate={onUpdate}
            onUndo={onUndo}
            returnFun={returnFun}
            collectShop={collectShop}
            disabled={disabled}
            disablePrint={disablePrint}
            collectDate={collectDate}
          />
        ) : null}
        {/* <Category
          title={'Delivering'}
          data={[
            {
              image:
                'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSN8V4fHd3cHJcSb90RQ_SuU4kU7Cl1gG8d1A&usqp=CAU',
              sku: 'sku-1',
              options: [
                {
                  content:
                    'Article Generator is an automatic online tool veloped to help t Article Generator is an automatic online too',
                  title:
                    'Article Generator is an automatic online tool developed to help t Article Generator is an automatic online too',
                },
                {
                  content: <DeliveryContent />,
                  title: 'Customized',
                },
                {
                  content: <DeliveryContent />,
                  title: 'Customized',
                },
                {
                  content:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                  title:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                },
                {
                  content:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                  title:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                },
              ],
            },
            {
              image:
                'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlrZqTCInyg6RfYC7Ape20o-EWP1EN_A8fOA&usqp=CAU',
              sku: 'sku-2',
              options: [
                { content: 1, title: 1 },
                { content: 1, title: 1 },
              ],
            },
            {
              image:
                'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEpOB50Gf-839DMNoHRlYYBAWP0TN73RHsGg&usqp=CAU',
              sku: 'sku-3',
              options: [
                {
                  content: <DeliveryContent />,
                  title: 'Customized',
                },
                {
                  content: <DeliveryContent />,
                  title: 'Customized',
                },

                {
                  content:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                  title:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                },
              ],
            },
          ]}
        />
        <Category
          title={'Done'}
          data={[
            {
              image:
                'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlrZqTCInyg6RfYC7Ape20o-EWP1EN_A8fOA&usqp=CAU',
              sku: 'sku-2',
              options: [
                { content: 1, title: 1 },
                { content: 1, title: 1 },
              ],
            },
            {
              image:
                'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEpOB50Gf-839DMNoHRlYYBAWP0TN73RHsGg&usqp=CAU',
              sku: 'sku-3',
              options: [
                {
                  content: <DeliveryContent />,
                  title: 'Customized',
                },
                {
                  content: <DeliveryContent />,
                  title: 'Customized',
                },

                {
                  content:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                  title:
                    'Article Generator is an automatic online tool developed to help those who want to create fresh content for any purpose, whether you need content for your website, SEO , blog, school or college Article Generator can do that for you in few seconds, without any effort.Article Generator is one of the best article writing tool online as it can rewrite unique content for your website, blog or college, unique articles can increase your website ranking in search engines and can get more traffic to your website.Just scroll below, add the keyword on the topic you want to generate articles and click generate articles to get fresh articles.',
                },
              ],
            },
          ]}
        /> */}
      </SectionWrapper>
    </React.Fragment>
  );
};
export default PickAndPack;
